import { useVIPEditorCreateVIPMutation } from '@graphql/generated';
import { VIPData } from '../components/VIPForm';
import { useToast } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

export const useAddVip = () => {
  const [mutation] = useVIPEditorCreateVIPMutation();
  const { toast } = useToast();
  const { tq } = useTranslation('VIPForm');

  const addVip = async (eventId: string, payload: VIPData) => {
    const { data, errors } = await mutation({
      variables: {
        payload: {
          eventId,
          ...payload,
        },
      },
    });

    if (errors || !data) {
      toast(tq`Failed to create VIP`);
      return null;
    }

    return data.createVip;
  };

  return { addVip };
};
